/**
 * Enum representing different types of result views.
 * Used for tracking performance metrics in Datadog for different result view contexts.
 */
export enum ResultViewType {
  STUDY = 'STUDY',
}
